import {
	SET_CANVAS_IMAGES,
	TOGGLE_LIGHTS,
	FETCH_CANVAS,
	SET_FRAME,
	SET_CANVAS,
	SET_HOVERED_LOT
} from "./constants";

export const fetchCanvas = () => (dispatch, getState) =>
	new Promise(resolve => {
		const state = getState();
		const canvas = {};
		dispatch({
			type: FETCH_CANVAS,
			canvas
		});
		resolve(canvas);
	});
export const setCanvas = routeName => dispatch =>
	new Promise(resolve => {
		dispatch({
			type: SET_CANVAS,
			routeName
		});
		resolve(routeName);
	});

export const getCanvas = ({ state }) => () =>
	new Promise(resolve => {
		resolve(state);
	});

export const setCanvasImages = images => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_CANVAS_IMAGES,
			images,
			building
		});

		resolve(images);
	});

export const toggleLights = () => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: TOGGLE_LIGHTS,
			building
		});

		resolve(true);
	});

export const setFrame = frame => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_FRAME,
			frame,
			building
		});

		resolve(frame);
	});

export const setHoveredLot = lot => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_HOVERED_LOT,
			lot,
			building
		});

		resolve(lot);
	});
